const fixed = () => {
    const areaFixedFunk = (fixedElm, fixedArea) => {
        const areas = document.querySelectorAll(fixedArea);
        if (areas.length === 0) {
            return;
        }

        let winHeight = 0;
        function getWindowHeight() {
            winHeight = window.innerHeight;
        }
        getWindowHeight();
        addEventListener('resize', getWindowHeight);

        const checkFixed = (target, area) => {
            let startPosi = area.getBoundingClientRect().top;
            let topValue = 230;
            const areaHeight = area.clientHeight;
            const endPosi = startPosi + areaHeight;
            const targetHeight = target.clientHeight;

            if (targetHeight > winHeight) {
                startPosi += (targetHeight - winHeight);
                topValue = winHeight - targetHeight;
            }

            const fixedReleasePoint = 310;

            if (0 > startPosi && (endPosi - targetHeight) > fixedReleasePoint) {
                target.setAttribute('data-fixed', '');
                target.style.top = topValue + 'px';

            } else if (0 <= startPosi) {
                target.removeAttribute('data-fixed');
                target.style.top = '';

            } else {
                target.removeAttribute('data-fixed');
                const bottomOffset = 260;
                target.style.top = (areaHeight - targetHeight - bottomOffset) + 'px';
            }
        }

        areas.forEach((area) => {
            const target = area.querySelector(fixedElm);
            if (target) {
                checkFixed(target, area);
                window.addEventListener('resize', () => {
                    checkFixed(target, area);
                });
                window.addEventListener('scroll', () => {
                    checkFixed(target, area);
                }, { passive: true });
            }
        });
    }

    areaFixedFunk('.js-fixed-elm', '.js-fixed-area');

}

const menuHighlight = () => {
  const menuHighlight = document.querySelector(".js-menu-highlight");
  if (!menuHighlight) return;

  const options = {
    root: null,
    rootMargin: "-60px 0px -66% 0px",
    threshold: 0
  };

  const sections = [];
  document.querySelectorAll(".js-menu-highlight a").forEach((link) => {
    const href = link.getAttribute("href");

    if (href && href.startsWith("#")) {
      const sectionId = href.substring(1);
      const section = document.getElementById(sectionId);

      if (section) {
        sections.push({ section, link });
      }
    }
  });

  if (sections.length === 0) return;

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      const linkData = sections.find(item => item.section === entry.target);
      if (!linkData) return;

      if (entry.isIntersecting) {
        document.querySelectorAll(".js-menu-highlight a").forEach((el) => {
          el.removeAttribute("data-active");
        });
        linkData.link.setAttribute("data-active", "");
      }
    });
  }, options);

  sections.forEach(({ section }) => {
    observer.observe(section);
  });
};

const more = () => {
  const initMore = () => {
    const historyContents = document.querySelectorAll('.js-more');

    historyContents.forEach(textContainer => {
      const button = textContainer.querySelector('button');

      if (!button) {
        console.warn('Button not found in:', textContainer);
        return;
      }

      const applyStyles = () => {
        const fullHeight = textContainer.scrollHeight;
        const maxClosedHeight = 580;

        if (window.innerWidth > 768) {
          textContainer.style.overflow = 'visible';
          textContainer.style.maxHeight = 'none';
          textContainer.style.transition = 'none';
          button.style.display = 'none';
          console.log('Large screen: moreを非表示化');
        } else {
          textContainer.style.overflow = 'hidden';
          button.style.display = '';

          const isInitiallyOpen = button.classList.contains('open');

          console.log('Button classes:', button.className, 'isInitiallyOpen:', isInitiallyOpen);
          console.log('fullHeight:', fullHeight, 'maxClosedHeight:', maxClosedHeight);

          if (isInitiallyOpen) {
            textContainer.style.maxHeight = maxClosedHeight + 'px';
          } else {
            textContainer.style.maxHeight = fullHeight + 'px';
          }

          textContainer.style.transition = 'max-height 0.4s ease';
        }
      };

      applyStyles();

      const handleResize = () => {
        applyStyles();
      };

      window.addEventListener('resize', handleResize);

      button.addEventListener('click', () => {
        if (window.innerWidth <= 768) {
          const fullHeight = textContainer.scrollHeight;
          const maxClosedHeight = 580;
          const isOpen = button.classList.contains('open');
          console.log('Clicked! isOpen:', isOpen);

          if (isOpen) {
            // openクラスがある = 現在は閉じた状態 → 開く
            textContainer.style.maxHeight = fullHeight + 'px';

            setTimeout(() => {
              button.classList.remove('open');
              console.log('Opened - removed open class');
            }, 400);

          } else {
            // openクラスがない = 現在は開いた状態 → 閉じる
            textContainer.style.maxHeight = maxClosedHeight + 'px';

            setTimeout(() => {
              button.classList.add('open');
              console.log('Closed - added open class');
            }, 400);
          }
        }
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMore);
  } else {
    initMore();
  }
};

const main = () => {
    if (document.querySelector('#page-company') == null) return;
    fixed();
    more();
    menuHighlight();
};

export default main;
